var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_540_3344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 51C102 51.5564 102 52.1127 101.947 52.6691C101.55 66.0218 95.8816 78.1558 87.0086 87.0312C78.1355 95.9065 65.0247 102 50.9868 102C50.4305 102 49.8743 102 49.3181 101.947C22.0634 101.073 0 78.5003 0 51C0 36.9849 5.7476 24.2151 14.9914 14.9688C24.2353 5.7226 36.9753 0 50.9868 0C64.9982 0 77.7647 5.7226 87.0086 14.9688C96.2524 24.2151 102 36.9849 102 51Z",
    fill: "#919BB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1954 22.0487C62.1989 22.9334 62.4594 35.7194 75.9954 36.5169C75.9954 40.2042 76 42.8777 76 46.3962C74.9749 46.4551 67.0887 45.8875 62.1806 41.5477L62.1657 60.7806C62.352 74.1296 52.442 82.253 39.4887 79.447C17.1523 72.8235 24.5746 39.9833 47.0024 43.4984C47.0024 54.1004 47.0081 43.495 47.0081 54.1004C37.7426 52.749 34.6434 60.3897 37.1061 65.8601C39.3459 70.841 48.5714 71.9206 51.7894 64.8938C52.154 63.5186 52.3357 61.9508 52.3357 60.1904V22L62.1954 22.0487Z",
    fill: "#071741"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_3344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.b06e391431ec48fe0a64f07452e038ec.svg";
export { ForwardRef as ReactComponent };